import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

import Logo from 'src/components/logo';
import type { NavProps } from 'src/components/nav-section/types';
import { useSettingsContext } from 'src/components/settings';
import SvgColor from 'src/components/svg-color';
// import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
import { bgBlur } from 'src/theme/css';

import AccountPopover from '../common/account-popover';
// import LanguagePopover from '../common/language-popover';
import { NAV, HEADER } from '../config-layout';

import GlobalSearch from './global-search';

// ----------------------------------------------------------------------

type Props = {
  data: NavProps['data'];
  hasNav?: boolean;
  onOpenNav?: VoidFunction;
};

export default function Header({ data, hasNav = true, onOpenNav }: Props) {
  const theme = useTheme();

  const settings = useSettingsContext();

  const isNavHorizontal = hasNav && settings.themeLayout === 'horizontal';

  const isNavMini = hasNav && settings.themeLayout === 'mini';

  const lgUp = useResponsive('up', 'lg');

  // const offset = useOffSetTop(HEADER.H_DESKTOP);

  // const offsetTop = offset && !isNavHorizontal;

  const renderContent = (
    <>
      {lgUp && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />}

      {!lgUp && hasNav && (
        <IconButton onClick={onOpenNav}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
        </IconButton>
      )}

      <Stack flexGrow={1} direction="row" alignItems="center" justifyContent="flex-end" spacing={{ xs: 0.5, sm: 1 }} sx={{ mt: 1 }}>
        {/* <LanguagePopover /> */}

        <GlobalSearch data={data} />

        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        // transition: theme.transitions.create(['height'], {
        //   duration: theme.transitions.duration.shorter,
        // }),
        ...(lgUp && {
          width: hasNav ? `calc(100% - ${NAV.W_VERTICAL + 1}px)` : 1,
          height: HEADER.H_DESKTOP,
          // ...(offsetTop && {
          //   height: HEADER.H_DESKTOP_OFFSET,
          // }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
